import React, { type FC } from 'react';
import { selectUnit } from '@formatjs/intl-utils';
import { graphql, useFragment } from 'react-relay';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl, FormattedRelativeTime } from '@atlassian/jira-intl';
import type { lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$key } from '@atlassian/jira-relay/src/__generated__/lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar.graphql';
import messages from './messages';

export const LastUpdatedTimestamp: FC<{
	intentTemplatesDataRef: lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$key;
}> = ({ intentTemplatesDataRef }) => {
	const { formatMessage } = useIntl();

	const intentTemplateData =
		useFragment<lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$key>(
			graphql`
				fragment lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar on VirtualAgentIntentTemplatesConnection
				@argumentDefinitions(isDiscoveredTemplatesTimestampEnabled: { type: "Boolean!" }) {
					lastDiscoveredTemplatesGenerationTime @include(if: $isDiscoveredTemplatesTimestampEnabled)
				}
			`,
			intentTemplatesDataRef,
		);

	if (intentTemplateData.lastDiscoveredTemplatesGenerationTime == null) {
		return null;
	}

	return (
		<Box xcss={textStyles}>
			{formatMessage(messages.lastUpdatedTimeText, {
				timestampMessage: (
					<FormattedRelativeTime
						{...selectUnit(new Date(intentTemplateData.lastDiscoveredTemplatesGenerationTime))}
					/>
				),
			})}
		</Box>
	);
};

const textStyles = xcss({
	color: 'color.text.accent.gray',
});
